import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { ThemeMode } from 'config';

import logoDark from 'assets/images/zignaai_logo.png';
import logo from 'assets/images/zignaai_logo.png';
import prodLogo from 'assets/images/logo_sutherland.png';

// ==============================|| LOGO SVG ||============================== //

const LogoMain = () => {
  const theme = useTheme();
  const isProd = import.meta.env.VITE_ENVIRONMENT === 'PROD';
  const logoSrc = isProd ? prodLogo : logo;
  const logoWidth = isProd ? 200 : 150;

  return <img src={logoSrc} alt="RightPx" width={logoWidth} />;
  // return <img src={theme.palette.mode === ThemeMode.DARK ? logoDark : logo} alt="RevMaxAI" width="150" />;
};

LogoMain.propTypes = {
  reverse: PropTypes.bool
};

export default LogoMain;
